import { render, staticRenderFns } from "./ListDesignPackagesComponent.vue?vue&type=template&id=27981d68&scoped=true"
import script from "./ListDesignPackagesComponent.vue?vue&type=script&lang=ts"
export * from "./ListDesignPackagesComponent.vue?vue&type=script&lang=ts"
import style0 from "./ListDesignPackagesComponent.vue?vue&type=style&index=0&id=27981d68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27981d68",
  null
  
)

export default component.exports